// HOZUMI Theme JavaScript

console.log('HOZUMI theme loaded');

// Placeholder - will be expanded
